(function() {
  function waitForElement(selector, callback) {
    // If element already exists, run immediately
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
      return;
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect(); // stop watching once found
        callback(el);
      }
    });

    observer.observe(document.body, {
      childList: true,  // watch for added/removed elements
      subtree: true     // watch all descendants, not just direct children
    });
  }
  function init() {
    const buttons = document.querySelectorAll('.bd-customer-trust__button, .trb-button');
    
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const target = document.querySelector('.jdgm-rev-widg');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // reviews banner rating average
    waitForElement('.jdgm-legacy-widget-content .jdgm-rev-widg__summary-average', (ratingAverageEle) => { 
      const ratingNumberEle = document.querySelector(".trb-rating-average");
      if (ratingNumberEle) {
        ratingNumberEle.textContent = ratingAverageEle.textContent;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
